<template>
    <div v-if="!loading">
        <div class="pb-3">
            <div class="subscriptions-header">
                <div class="feature-title"></div>
                <b-button v-for="(subscription, subscriptionIndex) in subscriptions" :key="subscriptionIndex"
                    @click="editSubscription(subscription, subscriptionIndex)" variant="primary" class="ml-1">
                    {{ subscription.title }}
                </b-button>
            </div>
            <div v-for="(featureGroup, featureGroupIndex) in featureGroups" :key="featureGroupIndex">
                <div class="p-1 text-white bg-info border rounded mt-2">{{ featureGroup.title }}</div>
                <div v-for="(feature, featureIndex) in featureGroup.features" class="feature-item border rounded"
                    :key="featureIndex">
                    <div class="p-1">{{ feature }}</div>
                    <div v-for="(subscription, subscriptionIndex) in subscriptions" :key="subscriptionIndex"
                        @click="toggleFeature(subscription, featureGroupIndex, featureIndex)"
                        class="text-center pointer pt-25 ml-1">
                        <span v-if="hasFeature(subscription, featureGroupIndex, featureIndex)">✔️</span>
                        <span v-else>❌</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit modal -->
        <b-modal id="modal-edit-subscription" title="ویرایش اشتراک" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <b-card-text class="p-1">
                <div class="mt-1">
                    <h6>نام اشتراک</h6>
                    <b-form-input class="text-center" v-model="subscription.title" />
                </div>
                <h6 class="mt-2">توضیحات اشتراک</h6>
                <b-form-input class="text-center" v-model="subscription.description" dir="rtl" />
                <div v-for="(duration, indexDuration) in subscription.durations" :key="indexDuration" class="mt-2">
                    <h6>مدت زمان اشتراک {{ indexDuration + 1 }}</h6>
                    <b-form-input class="text-center mb-2" v-model="duration.totalDays" dir="ltr" type="number" />
                    <h6>مبلغ اشتراک {{ indexDuration + 1 }}</h6>
                    <b-form-input class="text-center" v-model="duration.price" dir="ltr" type="number" />
                </div>
                <div class="d-flex align-items-center mt-3">
                    <b-button @click="addSubscription" class="w-50 mr-1" variant="secondary">
                        افزودن اشتراک
                    </b-button>
                    <b-button @click="updateSubscription" class="w-50" variant="primary">
                        ویرایش
                    </b-button>
                </div>
            </b-card-text>
        </b-modal>
    </div>
</template>

<script>
import { BCard, BCardText, BButton, BFormInput, BModal } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BFormInput,
        BModal
    },
    data() {
        return {
            loading: true,
            subscription: {},
            subscriptions: [],
            featureGroups: [],
            currentSubscriptionIndex: null
        };
    },
    computed: {
        globalFeatureIndices() {
            let globalIndex = 0;
            return this.featureGroups.reduce((indices, group) => {
                indices.push(...group.features.map(() => globalIndex++));
                return indices;
            }, []);
        }
    },
    methods: {
        addSubscription() {
            this.subscription.durations.push({ totalDays: null, price: null });
        },
        getGlobalFeatureIndex(featureGroupIndex, featureIndex) {
            let index = 0;
            for (let i = 0; i < featureGroupIndex; i++) {
                index += this.featureGroups[i].features.length;
            }
            return index + featureIndex;
        },
        hasFeature(subscription, featureGroupIndex, featureIndex) {
            const globalIndex = this.getGlobalFeatureIndex(featureGroupIndex, featureIndex);
            return subscription.features[globalIndex];
        },
        toggleFeature(subscription, featureGroupIndex, featureIndex) {
            const globalIndex = this.getGlobalFeatureIndex(featureGroupIndex, featureIndex);
            this.$set(subscription.features, globalIndex, !subscription.features[globalIndex]);
        },
        editSubscription(subscription, index) {
            this.subscription = { ...subscription };
            this.currentSubscriptionIndex = index;
            this.$bvModal.show('modal-edit-subscription');
        },
        async getSubscriptions() {
            this.loading = true
            await this.$axios.get('/Subscription').then((data) => {
                this.subscriptions = data.data.subscriptions
                this.featureGroups = data.data.featureGroups
                this.loading = false
            })
        },
        updateSubscription() {
            const { id, durations, features, order, title, description } = this.subscription;
            const data = { durations, features, order, title, description };
            adminService.changeSubscription(id, data).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$bvModal.hide('modal-edit-subscription');
                if (this.currentSubscriptionIndex !== null) {
                    this.subscriptions[this.currentSubscriptionIndex].title = title;
                    this.subscriptions[this.currentSubscriptionIndex].description = description;
                }
            })
                .catch(() => {
                    this.$notif({ type: 'error' });
                });

        },
    },
    mounted() {
        this.getSubscriptions();
    }
};
</script>


<style>
.subscriptions-header {
    display: grid;
    grid-template-columns: 6fr repeat(3, 3fr);
    margin-bottom: 20px;
}

.feature-item {
    display: grid;
    grid-template-columns: 6fr repeat(3, 3fr);
    align-items: center;
    margin-top: 10px;
}
</style>